'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DyzioDeleteButton = exports.DyzioModalActionButton = exports.DyzioCancelButton = exports.DyzioSecondaryButton = exports.DyzioPrimaryButton = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = require('semantic-ui-react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DyzioPrimaryButton = exports.DyzioPrimaryButton = function DyzioPrimaryButton(props) {
  var fluid = props.fluid,
      label = props.label,
      hasIcon = props.hasIcon,
      floated = props.floated,
      loading = props.loading,
      icon = props.icon,
      onClick = props.onClick,
      size = props.size,
      style = props.style,
      color = props.color,
      disabled = props.disabled,
      labelPosition = props.labelPosition;


  return _react2.default.createElement(
    _semanticUiReact.Button,
    {
      inverted: true,
      disabled: loading || disabled,
      fluid: fluid,
      size: size || 'medium',
      style: style,
      floated: floated,
      color: color || 'pink',
      icon: hasIcon,
      labelPosition: labelPosition,
      onClick: onClick,
      loading: loading
    },
    hasIcon && icon,
    label
  );
};

DyzioPrimaryButton.defaultProps = {
  labelPosition: 'left',
  floated: 'left'
};

var DyzioSecondaryButton = exports.DyzioSecondaryButton = function DyzioSecondaryButton(props) {
  var fluid = props.fluid,
      label = props.label,
      hasIcon = props.hasIcon,
      loading = props.loading,
      icon = props.icon,
      onClick = props.onClick,
      style = props.style,
      disabled = props.disabled,
      size = props.size,
      floated = props.floated,
      color = props.color,
      labelPosition = props.labelPosition;


  return _react2.default.createElement(
    _semanticUiReact.Button,
    {
      inverted: true,
      disabled: loading || disabled,
      fluid: fluid,
      size: size || 'medium',
      style: style,
      floated: floated,
      color: color || 'green',
      icon: hasIcon,
      labelPosition: labelPosition,
      onClick: onClick,
      loading: loading
    },
    hasIcon && icon,
    label
  );
};

DyzioSecondaryButton.defaultProps = {
  labelPosition: 'left',
  floated: 'left'
};

var DyzioCancelButton = exports.DyzioCancelButton = function DyzioCancelButton(props) {
  var fluid = props.fluid,
      label = props.label,
      hasIcon = props.hasIcon,
      loading = props.loading,
      icon = props.icon,
      onClick = props.onClick,
      style = props.style,
      disabled = props.disabled;


  var normalFontWeightStyle = (0, _extends3.default)({
    fontWeight: 700
  }, style);

  return _react2.default.createElement(
    _semanticUiReact.Button,
    {
      disabled: loading || disabled,
      fluid: fluid,
      style: normalFontWeightStyle,
      icon: hasIcon,
      labelPosition: 'left',
      onClick: onClick,
      loading: loading,
      className: 'dyzio-cancel-button'
    },
    hasIcon && icon,
    label
  );
};

var DyzioModalActionButton = exports.DyzioModalActionButton = function DyzioModalActionButton(props) {
  var fluid = props.fluid,
      label = props.label,
      hasIcon = props.hasIcon,
      loading = props.loading,
      color = props.color,
      icon = props.icon,
      onClick = props.onClick,
      style = props.style,
      disabled = props.disabled;


  var normalFontWeightStyle = (0, _extends3.default)({
    fontWeight: 700
  }, style);

  return _react2.default.createElement(
    _semanticUiReact.Button,
    {
      fluid: fluid,
      onClick: onClick,
      loading: loading,
      color: color,
      icon: hasIcon,
      disabled: loading || disabled,
      style: normalFontWeightStyle
    },
    hasIcon && icon,
    label
  );
};

DyzioModalActionButton.defaultProps = {
  color: 'pink'
};

var DyzioDeleteButton = exports.DyzioDeleteButton = function DyzioDeleteButton(props) {
  var fluid = props.fluid,
      label = props.label,
      hasIcon = props.hasIcon,
      floated = props.floated,
      loading = props.loading,
      icon = props.icon,
      onClick = props.onClick,
      size = props.size,
      color = props.color,
      disabled = props.disabled,
      labelPosition = props.labelPosition;


  return _react2.default.createElement(
    _semanticUiReact.Button,
    {
      inverted: true,
      disabled: loading || disabled,
      fluid: fluid,
      size: size || 'medium',
      floated: floated,
      color: 'red',
      icon: hasIcon,
      labelPosition: labelPosition,
      onClick: onClick,
      loading: loading
    },
    hasIcon && icon,
    label
  );
};

DyzioDeleteButton.propTypes = {
  onClick: _propTypes2.default.func.isRequired
};

DyzioDeleteButton.defaultProps = {
  label: 'Delete',
  hasIcon: true,
  icon: _react2.default.createElement(_semanticUiReact.Icon, { name: 'delete' }),
  labelPosition: 'left',
  floated: 'left'
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/components/dyzio-buttons/index.js
 ** module id = 73
 ** module chunks = 0
 **/